/* =============================================
   AOSM WATCH — Page Produit JS v2
============================================= */
(function () {
  'use strict';

  /* ---- Galerie miniatures ---- */
  var thumbs = document.querySelectorAll('.aosm-pd__thumb');
  var mainImg = document.getElementById('aosm-main-img');

  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        var alt = thumb.dataset.alt;
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.classList.remove('is-fading');
        }, 280);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Variants ---- */
  var variantsEl = document.getElementById('aosm-variants-json');
  if (!variantsEl) return;

  var variants = JSON.parse(variantsEl.textContent || '[]');
  var pills = document.querySelectorAll('.aosm-pd__pill');
  var variantIdInput = document.getElementById('aosm-variant-id');
  var priceEl = document.getElementById('aosm-price');
  var compareEl = document.getElementById('aosm-compare');
  var stockEl = document.getElementById('aosm-stock');
  var atcBtn = document.getElementById('aosm-atc-btn');

  var selectedOptions = {};

  pills.forEach(function (pill) {
    var idx = pill.dataset.optionIndex;
    if (pill.classList.contains('is-active')) {
      selectedOptions[idx] = pill.dataset.optionValue;
    }
  });

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function isPreorder(variantTitle) {
    if (!variantTitle) return false;
    var t = variantTitle.toLowerCase();
    return (
      t.indexOf('précommande') !== -1 ||
      t.indexOf('precommande') !== -1 ||
      t.indexOf('pre-order') !== -1 ||
      t.indexOf('preorder') !== -1
    );
  }

  function updateStock(matched) {
    if (!stockEl) return;
    var dot = stockEl.querySelector('.aosm-pd__stock-dot');
    var txt = stockEl.querySelector('.aosm-pd__stock-text');

    if (!matched.available) {
      dot.className = 'aosm-pd__stock-dot aosm-pd__stock-dot--out';
      txt.className = 'aosm-pd__stock-text';
      txt.textContent = 'Rupture de stock';
      return;
    }

    if (isPreorder(matched.title)) {
      dot.className = 'aosm-pd__stock-dot aosm-pd__stock-dot--preorder';
      txt.className = 'aosm-pd__stock-text aosm-pd__stock-text--preorder';
      txt.textContent = 'Précommande — expédié sous 20 jours';
      return;
    }

    if (matched.inventory_quantity > 0 && matched.inventory_quantity <= 5) {
      dot.className = 'aosm-pd__stock-dot aosm-pd__stock-dot--low';
      txt.className = 'aosm-pd__stock-text';
      txt.textContent = 'Plus que ' + matched.inventory_quantity + ' en stock';
      return;
    }

    dot.className = 'aosm-pd__stock-dot aosm-pd__stock-dot--ok';
    txt.className = 'aosm-pd__stock-text';
    txt.textContent = 'En stock — expédition rapide';
  }

  function updateVariant() {
    var opts = [];
    Object.keys(selectedOptions).sort().forEach(function (k) {
      opts.push(selectedOptions[k]);
    });

    var matched = null;
    variants.forEach(function (v) {
      var match = opts.every(function (opt, i) {
        return v['option' + (i + 1)] === opt;
      });
      if (match) matched = v;
    });

    if (!matched) return;

    if (variantIdInput) variantIdInput.value = matched.id;

    if (priceEl) priceEl.textContent = formatMoney(matched.price);

    if (compareEl) {
      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        compareEl.textContent = formatMoney(matched.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    updateStock(matched);

    if (atcBtn) {
      var label = atcBtn.querySelector('.aosm-pd__atc-label');
      if (matched.available) {
        atcBtn.disabled = false;
        if (label) {
          label.textContent = isPreorder(matched.title)
            ? 'Précommander'
            : 'Ajouter au panier';
        }
      } else {
        atcBtn.disabled = true;
        if (label) label.textContent = 'Indisponible';
      }
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var idx = pill.dataset.optionIndex;
      var val = pill.dataset.optionValue;

      document.querySelectorAll('.aosm-pd__pill[data-option-index="' + idx + '"]').forEach(function (p) {
        p.classList.remove('is-active');
      });
      pill.classList.add('is-active');

      var selectedDisplay = document.getElementById('aosm-opt-' + (parseInt(idx) + 1));
      if (selectedDisplay) selectedDisplay.textContent = val;

      selectedOptions[idx] = val;
      updateVariant();
    });
  });

  /* ---- ATC feedback ---- */
  var atcForm = document.getElementById('aosm-atc-form');
  if (atcForm && atcBtn) {
    atcForm.addEventListener('submit', function () {
      if (atcBtn.disabled) return;
      var label = atcBtn.querySelector('.aosm-pd__atc-label');
      atcBtn.classList.add('is-added');
      if (label) label.textContent = 'Ajouté ✓';
      setTimeout(function () {
        atcBtn.classList.remove('is-added');
        var currentVariantId = variantIdInput ? variantIdInput.value : null;
        var current = variants.find(function(v){ return v.id == currentVariantId; });
        if (label && current) {
          label.textContent = isPreorder(current.title)
            ? 'Précommander'
            : 'Ajouter au panier';
        }
      }, 2000);
    });
  }

})();
